import { quotationDashboardState, quotationsState, quotationProformaState, quotationCootjeState, quotationSummaryState, quotationComparisonState } from './quotations.states';
import { quotationsComponent } from './quotations.component';
import { quotationsDashboardComponent } from './quotations.dashboard.component';
import { loadNg1Module, ngmodule } from "../../bootstrap/ngmodule";
import { InvoicesService, TwinfieldService } from "../../services/index";
import { invoiceDetailsComponent } from "./invoiceDetails.component";
import { quotationsCootjeComponent } from './quotations.cootje.component';
import { quotationsSummaryComponent } from './quotations.summary.component';
import { quotationsComparisonComponent } from './quotations.comparison.component';
import { CootjeService } from '../../services/cootje.service';
const quotationsAppModule: aboTheme.INgModule = {
    components: { quotationsComponent, quotationsDashboardComponent, invoiceDetailsComponent, quotationsCootjeComponent, quotationsSummaryComponent, quotationsComparisonComponent },
    states: [ quotationsState, quotationDashboardState, quotationProformaState, quotationCootjeState, quotationSummaryState, quotationComparisonState ],
    services: { InvoicesService, TwinfieldService, CootjeService }
};

loadNg1Module(ngmodule, quotationsAppModule);



// WEBPACK FOOTER //
// ./src/app/modules/quotations/index.ts